"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHighcharts = _interopRequireDefault(require("react-highcharts"));

var _heatmap = _interopRequireDefault(require("highcharts/modules/heatmap"));

var _highchartsCustomEvents = _interopRequireDefault(require("highcharts-custom-events"));

var _objectHash = _interopRequireDefault(require("object-hash"));

var _chartDataPropTypes = require("../manipulate/chartDataPropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Highcharts = _reactHighcharts["default"].Highcharts;
(0, _heatmap["default"])(Highcharts);
(0, _highchartsCustomEvents["default"])(Highcharts);

var stringWidthInPixels = function stringWidthInPixels(strLength, averageCharWidth, rotationInDeg) {
  return strLength * averageCharWidth * Math.cos(rotationInDeg * Math.PI / 180);
};

var stringHeightInPixels = function stringHeightInPixels(strLength, averageCharWidth, rotationInDeg) {
  return strLength * averageCharWidth * Math.sin(rotationInDeg * Math.PI / 180);
}; // Custom Events default behaviour disables context menu on right-click, we bring it back


window.oncontextmenu = function () {
  return true;
};

var HeatmapCanvas = /*#__PURE__*/function (_React$Component) {
  _inherits(HeatmapCanvas, _React$Component);

  var _super = _createSuper(HeatmapCanvas);

  function HeatmapCanvas(props) {
    _classCallCheck(this, HeatmapCanvas);

    return _super.call(this, props);
  }

  _createClass(HeatmapCanvas, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      // Callback that does setState fails: https://github.com/kirjs/react-highcharts/issues/245
      // Don’t call render again after zoom happens
      return _objectHash["default"].MD5([nextProps.heatmapData, nextProps.events.onClick, nextProps.withAnatomogram, nextProps.currentGenomeBrowser]) !== _objectHash["default"].MD5([this.props.heatmapData, this.props.events.onClick, this.props.withAnatomogram, this.props.currentGenomeBrowser]);
    }
  }, {
    key: "_countColumns",
    value: function _countColumns() {
      return this.props.heatmapData.xAxisCategories.length;
    }
  }, {
    key: "_getAutoRotationBasedOnLastLabelsLength",
    value: function _getAutoRotationBasedOnLastLabelsLength() {
      // If any of the last four labels is longer than 30 chars make the labels vertical, ymmv, change if needed
      var tailLength = 4;
      var maxChars = 30;
      var lastLabels = this.props.heatmapData.xAxisCategories.map(function (category) {
        return category.label;
      }).slice(-tailLength);
      return lastLabels.some(function (label) {
        return label.length > maxChars;
      }) ? [-90] : [-45];
    }
  }, {
    key: "_getColumnWidthInPixels",
    value: function _getColumnWidthInPixels() {
      // The anatomogram takes 20% of the total div width
      var containerDivWidth = this.props.withAnatomogram ? document.getElementsByClassName("gxaHeatmapContainer")[0].clientWidth * 0.80 : document.getElementsByClassName("gxaHeatmapContainer")[0].clientWidth;
      var longestRowLabelLength = Math.max.apply(Math, _toConsumableArray(this.props.heatmapData.yAxisCategories.map(function (category) {
        return category.label.length;
      })));
      var yAxisAvgCharWidth = 8.75;
      var yAxisPadding = 12;
      var heatmapWidth = containerDivWidth - stringWidthInPixels(longestRowLabelLength, yAxisAvgCharWidth, 0) - yAxisPadding;
      return heatmapWidth / this.props.heatmapData.xAxisCategories.length;
    }
  }, {
    key: "_xAxisLabelsRotationAngle",
    value: function _xAxisLabelsRotationAngle() {
      var columnWidth = this._getColumnWidthInPixels();

      var longestColumnLabelLength = Math.max.apply(Math, _toConsumableArray(this.props.heatmapData.xAxisCategories.map(function (category) {
        return category.label.length;
      })));
      var labelLengthToWidthRatio = longestColumnLabelLength / columnWidth; // Ratio cutoff based on trial and error...

      return labelLengthToWidthRatio < 0.2 ? 0 : this._getAutoRotationBasedOnLastLabelsLength()[0];
    }
  }, {
    key: "_getAdjustedMarginRight",
    value: function _getAdjustedMarginRight() {
      var minMarginRight = 20;

      var xAxisLabelsRotationAngle = this._xAxisLabelsRotationAngle();

      if (xAxisLabelsRotationAngle === 0 || xAxisLabelsRotationAngle === -90) {
        return minMarginRight;
      } else {
        var columnWidth = this._getColumnWidthInPixels();

        var longestColumnLabelWidthNearTheTailInPixels = stringWidthInPixels(Math.max.apply(Math, _toConsumableArray(this.props.heatmapData.xAxisCategories.slice(-4).map(function (category) {
          return category.label.length;
        }))), 6, 45); // We divide by two because the label is placed in the middle of the column

        return Math.max(minMarginRight, longestColumnLabelWidthNearTheTailInPixels - columnWidth / 2);
      }
    }
  }, {
    key: "_getMarginTop",
    value: function _getMarginTop() {
      var minMarginTop = 30;
      var xAxisLabelAvgCharWidth = 6;

      var xAxisLabelsRotationAngle = this._xAxisLabelsRotationAngle();

      var longestColumnLabelLength = Math.max.apply(Math, _toConsumableArray(this.props.heatmapData.xAxisCategories.map(function (category) {
        return category.label.length;
      })));
      return xAxisLabelsRotationAngle === 0 ? minMarginTop : stringHeightInPixels(longestColumnLabelLength, xAxisLabelAvgCharWidth, Math.abs(xAxisLabelsRotationAngle));
    }
  }, {
    key: "_getHeight",
    value: function _getHeight(marginBottom) {
      var rowCount = this.props.heatmapData.yAxisCategories.length;
      return rowCount * 40 + this._getMarginTop() + marginBottom;
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var marginBottom = 10;

      var marginRight = this._getAdjustedMarginRight();

      var height = this._getHeight(marginBottom);

      var _this$props = this.props,
          cellTooltipFormatter = _this$props.cellTooltipFormatter,
          xAxisFormatter = _this$props.xAxisFormatter,
          yAxisFormatter = _this$props.yAxisFormatter,
          events = _this$props.events,
          onZoom = _this$props.onZoom,
          noDataCellsColour = _this$props.noDataCellsColour,
          currentGenomeBrowser = _this$props.currentGenomeBrowser;
      var highchartsConfig = {
        chart: {
          marginBottom: marginBottom,
          marginRight: marginRight,
          height: height,
          type: "heatmap",
          plotBackgroundColor: noDataCellsColour,
          spacingTop: 0,
          plotBorderWidth: 1,
          events: {
            handleGxaAnatomogramTissueMouseEnter: function handleGxaAnatomogramTissueMouseEnter(e) {
              var selectedPoints = this.getSelectedPoints();

              if (selectedPoints.length > 0) {
                Highcharts.each(selectedPoints, function (point) {
                  point.select(false);
                });
              }

              Highcharts.each(this.series, function (series) {
                Highcharts.each(series.points, function (point) {
                  if (e.svgPathIds.includes(point.series.xAxis.categories[point.x].id)) {
                    point.select(true, true);
                  }
                });
              });
            }
          },
          zoomType: "x"
        },
        plotOptions: {
          heatmap: {
            turboThreshold: 0
          },
          series: {
            cursor: events.onClick ? "pointer" : undefined,
            point: {
              events: {
                click: events.onClick ? function () {
                  events.onClick(this.x, this.y, currentGenomeBrowser);
                } : function () {},
                mouseOver: function mouseOver() {
                  events.onHoverPoint(this.x);
                },
                mouseOut: function mouseOut() {
                  events.onHoverOff();
                }
              }
            },
            states: {
              hover: {
                color: "#eeec38" //#edab12 color cell on mouse over

              },
              select: {
                color: "#eeec38"
              }
            }
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: false
        },
        title: null,
        colorAxis: this.props.colourAxis,
        xAxis: {
          //assay groups, contrasts, or factors across experiments
          tickLength: 5,
          tickColor: "rgb(192, 192, 192)",
          lineColor: "rgb(192, 192, 192)",
          labels: {
            style: this.props.xAxisStyle,
            // Events in labels enabled by 'highcharts-custom-events'
            events: {
              mouseover: function mouseover() {
                events.onHoverColumnLabel(this.value);
              },
              mouseout: function mouseout() {
                events.onHoverOff();
              }
            },
            autoRotation: this._getAutoRotationBasedOnLastLabelsLength(),
            formatter: function formatter() {
              return xAxisFormatter(this.value);
            }
          },
          opposite: "true",
          categories: this.props.heatmapData.xAxisCategories,
          min: 0,
          max: this._countColumns() - 1,
          events: {
            setExtremes: function setExtremes(event) {
              onZoom(event.min !== undefined && event.max !== undefined);
            }
          }
        },
        yAxis: {
          //experiments or bioentities
          useHTML: true,
          reversed: true,
          labels: {
            useHTML: true,
            style: this.props.yAxisStyle,
            events: {
              mouseover: function mouseover() {
                events.onHoverRowLabel(this.value);
              },
              mouseout: function mouseout() {
                events.onHoverOff();
              }
            },
            formatter: function formatter() {
              return yAxisFormatter(this.value);
            }
          },
          categories: this.props.heatmapData.yAxisCategories,
          title: null,
          gridLineWidth: 0,
          minorGridLineWidth: 0,
          endOnTick: false
        },
        tooltip: {
          useHTML: true,
          shared: false,
          borderRadius: 0,
          borderWidth: 0,
          shadow: false,
          enabled: true,
          backgroundColor: "none",
          outside: true,
          formatter: function formatter() {
            return cellTooltipFormatter(this.series, this.point);
          }
        },
        series: this.props.heatmapData.dataSeries.map(function (e) {
          return {
            name: e.info.name,
            color: e.info.colour,
            borderWidth: _this._countColumns() > 200 ? 0 : 1,
            borderColor: "white",
            data: e.data
          };
        })
      }; // const maxWidthFraction = this._countColumns() > 6 ? 1 : Math.max(0.5, 1 - Math.exp(-(1 + 0.05 * Math.pow(1 + this._countColumns(), 2))))

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactHighcharts["default"], {
        ref: function ref(_ref) {
          return _this.highchartsRef = _ref;
        },
        config: highchartsConfig
      }));
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var chart = this.highchartsRef.getChart();
      Highcharts.fireEvent(chart, "handleGxaAnatomogramTissueMouseEnter", {
        svgPathIds: nextProps.ontologyIdsToHighlight
      });
    }
  }]);

  return HeatmapCanvas;
}(_react["default"].Component);

HeatmapCanvas.propTypes = {
  heatmapData: _chartDataPropTypes.heatmapDataPropTypes.isRequired,
  noDataCellsColour: _propTypes["default"].string,
  colourAxis: _chartDataPropTypes.colourAxisPropTypes,
  // Only for experiment heatmap
  cellTooltipFormatter: _propTypes["default"].func.isRequired,
  xAxisFormatter: _propTypes["default"].func.isRequired,
  xAxisStyle: _propTypes["default"].object.isRequired,
  yAxisFormatter: _propTypes["default"].func.isRequired,
  yAxisStyle: _propTypes["default"].object.isRequired,
  ontologyIdsToHighlight: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  events: _propTypes["default"].shape({
    onHoverRowLabel: _propTypes["default"].func.isRequired,
    onHoverColumnLabel: _propTypes["default"].func.isRequired,
    onHoverPoint: _propTypes["default"].func.isRequired,
    onHoverOff: _propTypes["default"].func.isRequired,
    onClick: _propTypes["default"].func
  }),
  onZoom: _propTypes["default"].func.isRequired,
  withAnatomogram: _propTypes["default"].bool.isRequired,
  currentGenomeBrowser: _propTypes["default"].string.isRequired
};
HeatmapCanvas.defaultProps = {
  noDataCellsColour: "white"
};

var Main = function Main(props) {
  return props.heatmapData.yAxisCategories.length < 1 ? /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      padding: "50px 0"
    }
  }, "No data match your filtering criteria or your original query. Please, change your query or your filters and try again.") : /*#__PURE__*/_react["default"].createElement(HeatmapCanvas, props);
};

var _default = Main;
exports["default"] = _default;